import { createSlice } from "@reduxjs/toolkit";

const initialState = window.User || {
  isLogged: null,
  data: null,
  balance: {
    points: 0,
    balance: 0,
    cashbackLevel: 0,
    levelPoints: 0,
  },
  notifications: 0,
};

const userSlice = createSlice({
  name: "User",
  initialState,
  reducers: {
    Ping: (state, action) => {
      state.isLogged = action.payload.isLogged;
      //state.isLogged=true;
      state.data = action.payload.data;
    },
    setBalance: (state, action) => {
      if (action.payload)
        state.balance = {
          points: action.payload["points"]
            ? action.payload["points"]
            : state.balance?.points,
          balance: action.payload["gel"]
            ? action.payload["gel"]
            : state.balance?.balance,
          cashbackLevel: action.payload["cashback-level"]
            ? action.payload["cashback-level"]
            : state.balance?.cashbackLevel,
          levelPoints: action.payload["level-points"]
            ? action.payload["level-points"]
            : state.balance?.levelPoints,
        };
    },
    setNotifications: (state, action) => {
      if (action.payload) state.notifications = action.payload;
    },
  },
});
export const { Ping, setBalance, setNotifications } = userSlice.actions;

export default userSlice.reducer;
